import React from 'react';
import PropTypes from 'prop-types';
import { useSearchBar } from './hooks/useSearchBar';
import './SearchBar.scss';

const SearchBar = ({
  placeholder = 'Search...',
  className = '',
  disabled = false,
  showClearButton = true,
  width = '100%',
  height = '32px',
  initialValue = '',
  onSearchChange,
  debounceMs = 0,
  clearOnMount = false,
}) => {
  const {
    searchTerm,
    handleSearchChange,
    handleClearSearch,
    isSearching,
  } = useSearchBar({
    initialValue,
    onSearchChange,
    debounceMs,
    clearOnMount,
  });

  return (
    <div className={`search-bar-container ${className}`} style={{ width, height }}>
      <div className="search-bar-input-wrapper">
        <input
          type="text"
          className="search-bar-input"
          placeholder={placeholder}
          value={searchTerm}
          onChange={handleSearchChange}
          disabled={disabled}
          style={{ height }}
        />
        {showClearButton && isSearching && (
          <button
            type="button"
            className="search-bar-clear-button"
            onClick={handleClearSearch}
            disabled={disabled}
          >
            ×
          </button>
        )}
      </div>
    </div>
  );
};

SearchBar.propTypes = {
  placeholder: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  showClearButton: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  initialValue: PropTypes.string,
  onSearchChange: PropTypes.func,
  debounceMs: PropTypes.number,
  clearOnMount: PropTypes.bool,
};

export default SearchBar;



// WEBPACK FOOTER //
// ./src/components/SearchBar/SearchBar.js